import { render } from "./EmailList.vue?vue&type=template&id=4d3a1363&scoped=true&ts=true"
import script from "./EmailList.vue?vue&type=script&lang=ts"
export * from "./EmailList.vue?vue&type=script&lang=ts"

import "./EmailList.vue?vue&type=style&index=0&id=4d3a1363&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3a1363"]])

export default __exports__